import { toast } from 'react-toastify'

export const openErrorToaster = ({ message, toasterId = '' }) => {
  toast.error(message, {
    position: 'top-center',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
    // className: 'toast-orange-background'
  })
}

export const openSuccessToaster = ({ message, toasterId = '' }) => {
  toast.success(message, {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
    // className: 'toast-orange-background'
  })
}

export const openErrorWireToaster = ({ message, toasterId = '' }) => {
  toast.error(message, {
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
    // className: 'toast-orange-background'
  })
}

export const openSuccessWireToaster = ({ message, toasterId = '' }) => {
  toast.success(message, {
    // position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}`
    // className: 'toast-orange-background'
  })
}
